// extracted by mini-css-extract-plugin
var _1 = "EntityPhaseItemTooltip-moduleEntityPhaseItemTooltip__CYK5O";
var _2 = "EntityPhaseItemTooltip-moduleadditionalInfo__WknOV";
var _3 = "EntityPhaseItemTooltip-modulename__vZQom";
export { _1 as "EntityPhaseItemTooltip", _2 as "additionalInfo", _3 as "name" }
